import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { sendRudderstackEvent } from 'dpl/util/analytics';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURES
} from 'dpl/constants/analytics';
import { capitalize } from 'dpl/shared/utils';
import ImagePlaceholder from 'dpl/components/MediaGrid/ImagePlaceholder';
import SmartImage from 'dpl/components/SmartImage';
import ClickableDiv from 'dpl/common/components/ClickableDiv';

import { openPuppyPage } from '../utils/helpers';

export default function SiblingPuppyCard({ analytics, puppy }) {
  const smartImageProps = {
    Tag: 'div',
    className: 'w-100 bg-center cover br3 br--top',
    crop: true,
    loadingClass: 'bg-light-gray',
    height: '210px',
    allowContextMenu: true
  };

  function handleClick() {
    sendRudderstackEvent(ANALYTICS_EVENTS.CARD_CLICKED_BY_USER, {
      ...analytics,
      breed_id: puppy.breed_id,
      dog_id: puppy.id,
      view_feature: ANALYTICS_VIEW_FEATURES.PUPPY_CARD
    });

    openPuppyPage({ puppyId: puppy.id }, '_self');
  }

  return (
    <ClickableDiv onClick={handleClick}>
      <div className="SiblingPuppyCard h-100 flex flex-column br3 ba b--light-gray overflow-hidden">
        {puppy.profile_photo_url ? (
          <SmartImage src={puppy.profile_photo_url} {...smartImageProps} />
        ) : (
          <ImagePlaceholder className="bg-branch-light" />
        )}
        <div className="pv4 ph4">
          <div className="flex items-center justify-between">
            <p className="font-serif f4 truncate">{puppy.name}</p>
            <p
              className={classnames(
                'br-pill pv1 ph4 f1',
                puppy.available
                  ? 'bg-stroll-light stroll'
                  : 'bg-rubber-light rubber-dark'
              )}
            >
              {puppy.available ? 'Available' : 'Reserved'}
            </p>
          </div>
          {puppy.gender && (
            <p className="secondary mt1">{capitalize(puppy.gender)}</p>
          )}
        </div>
      </div>
    </ClickableDiv>
  );
}

SiblingPuppyCard.propTypes = {
  analytics: PropTypes.shape({
    breeder_profile_id: PropTypes.number,
    litter_id: PropTypes.number,
    position: PropTypes.number,
    view: PropTypes.string,
    view_feature_location: PropTypes.string
  }),
  puppy: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    profile_photo_url: PropTypes.string,
    gender: PropTypes.string,
    available: PropTypes.bool,
    breed_id: PropTypes.number
  }).isRequired
};

SiblingPuppyCard.defaultProps = {
  analytics: {}
};
